module.exports = __webpack_public_path__ + "img/home-img-people-4.5cec40cf.jpg";